import { api } from '@jurnee/common/src/browser/Api';
import { Language } from '@jurnee/common/src/entities/Language';
import { List } from '@jurnee/common/src/serializers';

export function getLanguages(): Promise<List<Language, never>> {
  return api.get('languages');
}